import EN from './EN'
import CH from './CH'
import JP from './JP'

export default {
  EN,
  JP,
  CH,
}
